import { differenceInYears, startOfMonth, endOfMonth, startOfWeek, endOfWeek, parse, formatDistanceToNow, toDate } from 'date-fns';

/**
 * Utility class to manage Date & Time related functions
 * This class would host only pure functions without any mutations
 * import DateUtil class into any component from the SharedModule
 * All functions of this class would be public and static
 */
export class DateUtil {
  /**
   * Adds time to a date. Modelled after MySQL DATE_ADD function.
   * Example: dateAdd(new Date(), 'minute', 30)  // returns 30 minutes from now.
   *
   * @param date  Date to start with
   * @param interval  One of: year, quarter, month, week, day, hour, minute, second
   * @param units  Number of units of the given interval to add.
   */
  public static dateAdd(date, interval, units): Date {
    // TODO: Replace this with date-fns addYears, addQuarters, addMonths, addWeeks, addDays etc...
    let ret = new Date(date); // don't change original date
    const checkRollover = () => {
      if (ret.getDate() !== date.getDate()) {
        ret.setDate(0);
      }
    };
    switch (interval.toLowerCase()) {
      case 'year':
        ret.setFullYear(ret.getFullYear() + units);
        checkRollover();
        break;
      case 'quarter':
        ret.setMonth(ret.getMonth() + 3 * units);
        checkRollover();
        break;
      case 'month':
        ret.setMonth(ret.getMonth() + units);
        checkRollover();
        break;
      case 'week':
        ret.setDate(ret.getDate() + 7 * units);
        break;
      case 'day':
        ret.setDate(ret.getDate() + units);
        break;
      case 'hour':
        ret.setTime(ret.getTime() + units * 3600000);
        break;
      case 'minute':
        ret.setTime(ret.getTime() + units * 60000);
        break;
      case 'second':
        ret.setTime(ret.getTime() + units * 1000);
        break;
      default:
        ret = undefined;
        break;
    }
    return ret;
  }

  /**
   * Calculate the Age in years given the date of birth
   * @param dobD Date of birth - date object
   */
  public static getAge(dobD: Date): number {
    if (!dobD) {
      return 0;
    } // rare case of missing dobD value
    return differenceInYears(new Date(), new Date(dobD));
  }

  // From date-fns
  public static getStartOfWeek(date: Date): Date {
    return startOfWeek(new Date(date));
  }

  public static getEndOfWeek(date: Date): Date {
    return endOfWeek(new Date(date));
  }

  public static getStartOfMonth(date: Date): Date {
    return startOfMonth(new Date(date));
  }

  public static getEndOfMonth(date: Date): Date {
    return endOfMonth(new Date(date));
  }

  public static parseDate(dateString: string): Date {
    // return parse(dateString);
    // return new Date(dateString);
    return toDate(new Date(dateString));
  }

  public static fromNow(date: Date): string {
    return formatDistanceToNow(new Date(date));
  }
}
